import { AccountingAccount } from "../models/accounting.account.model";
import { Names } from "../models/names.model";

export function accountingAccountId(list: AccountingAccount[], code: string): string {
  return list?.find((item) => (item.code === code))?.id ?? ''
}

export function accountingAccountCode(list: AccountingAccount[], id: string): string {
  return list?.find((item) => (item.id === id))?.code ?? ''
}

export function accountingAccountName(list: AccountingAccount[], company_language: string, id: string): string {
  return list?.find((item) => (item.id === id))?.name[company_language.toLowerCase() as keyof Names] ?? ''
}

export function accountingAccountRebate(list_all: AccountingAccount[], list_income: AccountingAccount[], id: string): string {
  let ranges: {start: number, end: number, rebate: string}[] = [
    { start: 3000, end: 3000.99, rebate: '3091' },
    { start: 3200, end: 3200.99, rebate: '3291' },
    { start: 3400, end: 3400.99, rebate: '3491' },
    { start: 3600, end: 3600.99, rebate: '3691' }
  ]

  let accountCode: number = parseFloat(accountingAccountCode(list_income, id))
  let accountRebate: string = (!isNaN(accountCode)) ? (ranges.find((item) => (accountCode >= item.start && accountCode <= item.end))?.rebate ?? '') : ''

  return list_all.find((item) => (item.code === accountRebate))?.id ?? ''
}

export function accountingAccountReduction(list_all: AccountingAccount[], list_expense: AccountingAccount[], id: string): string {
  let ranges: {start: number, end: number, rebate: string}[] = [
    { start: 4200, end: 4200.99, rebate: '4291' },
    { start: 4400, end: 4400.99, rebate: '4491' }
  ]

  let accountCode: number = parseFloat(accountingAccountCode(list_expense, id))
  let accountReduction: string = (!isNaN(accountCode)) ? (ranges.find((item) => (accountCode >= item.start && accountCode <= item.end))?.rebate ?? '') : ''

  return list_all.find((item) => (item.code === accountReduction))?.id ?? ''
}
